import {observer} from 'mobx-react-lite'
import React from 'react'
import {ApiUi} from '@api/components'
import {addingAllowed} from '@client/hub-actions-allowed'
import {AddTask} from '@components/add-task'
import {ColumnMenu} from '@components/columns/column-menu'
import {useColumnStore} from '@components/columns/column-store'
import {AggregatedStickerValues} from '@components/columns/column-title/aggregated-sticker-values'
import {
  TwTaskGroupTitle,
  TwTitleRow
} from '@components/columns/column-title/containers'
import {EditableColumnTitle} from '@components/columns/column-title/editable-column-title'
import {MultiActionsCheckbox} from '@components/columns/column-title/multi-actions-checkbox'

export const BasicColumnHeader = observer(() => {
  const [state, store] = useColumnStore()

  return (
    <TwTaskGroupTitle
      onDrop={store.onDrop}
      onDragOver={store.onDragOver}
      onDragLeave={store.onDragLeave}
      className="px-8 pt-8 pb-4"
    >
      <TwTitleRow className="min-h-24">
        <MultiActionsCheckbox columnId={store.column.id} />
        <EditableColumnTitle type="basic" />
        <ColumnMenu className="flex-none -mx-4" />
      </TwTitleRow>
      <ApiUi category="column-header" id={store.column.id} />
      {Boolean(state.numericStickersSum.size) && (
        <TwTitleRow>
          <AggregatedStickerValues />
        </TwTitleRow>
      )}
      {addingAllowed(store.column.id) && (
        <TwTitleRow className="!block">
          <AddTask columnId={store.column.id} scrollTo="task-center" />
        </TwTitleRow>
      )}
    </TwTaskGroupTitle>
  )
})
